import { Group, Layout, Page } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { useFetch, useForm, useStore, useToast, useModal, usePage, useTheme, useResource } from "@/comn/hooks";
import {
    URLS,
    APIS,
    SF_BTBDMS_MGMT,
    labelConversionMap,
} from "@/tra/tancis/ptli/ptl/btbdms/services/PtliBtbdmsService";
import { useRef, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { TFormSchema } from "@/comn/hooks";

/*
 * Common Bulletin Board(Bulletin board message) Registration
 * !== 공통 게시판(게시글) 등록 ==!
 */

export const PTLI1018003S = (): JSX.Element => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0001", "auth_ptli0015", "auth_ptlianyADM", "auth_ptli0019", "auth_ptli0061"],
    });
    const { t } = useTranslation();
    const navigate = useNavigate();
    const toast = useToast();
    const modal = useModal();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const [bltbrdInfo, setBltbrdInfo] = useState<bltbrd>();
    const { bltbrdUuid: bltbrdUuid } = useParams(); // Bulletin board ID
    const [ppupYn, setPpupYn] = useState<boolean>(false);
    const [subCategory, setSubCategory] = useState<SubCategoryItem[]>([]);
    const { theme } = useTheme();
    const lang = theme.lang;

    useResource({
        defaultSchema: [{ area: "orgz" }, { area: "cstmOfcrCd" }],
    });

    type SubCategoryItem = {
        comnCd: string;
        uprCdVldVal: string;
    };

    // Bulletin board Interface !== 게시판 ==!
    interface bltbrd {
        bltbrdUuid: string;
        bltbrdKoNm: string;
        bltbrdEngNm: string;
        bltbrdTzNm: string;
        btbdrpUseYn: string;
        btbdcmUseYn: string;
        btbdrpBtbdcmUseYn: string;
        ppupSettPsblYn: string;
        atcmUseYn: string;
        atcmUpldLmtNo: Number;
        atcmCapcLmtYn: string;
        atcmLmtCapc: number;
        secrtBtbdmsUseYn: string;
        selcCntUseYn: string;
        chgYn: string;
        btbdmsSelcExuseYn: string;
        btbdrpSelcExuseYn: string;
        btbdrpSttsUseYn: string;
        relaBltbrdUseYn: string;
        btbdmsTpCdValList: any;
        reLaBltbrdList: any;
    }

    const form = {
        btbdms: useForm({
            defaultSchema: SF_BTBDMS_MGMT,
            defaultValues: { ...pgeStore?.form },
        }),
    };

    const fetch = {
        // get Bulletin board Management Information !== 게시판 관리 정보 조회==!
        getBltbrdInfo: useFetch({
            api: () => APIS.getBltbrdInfo(bltbrdUuid),
            onSuccess: (data: any) => {
                const apiBrdInfo = data.bltbrdInfo.content;
                // Managing bulletin board management information as state !== 게시판 관리정보 State로 관리 ==!
                setBltbrdInfo({
                    bltbrdUuid: apiBrdInfo.bltbrdUuid,
                    bltbrdKoNm: apiBrdInfo.bltbrdKoNm,
                    bltbrdEngNm: apiBrdInfo.bltbrdEngNm,
                    bltbrdTzNm: apiBrdInfo.bltbrdTzNm,
                    btbdrpUseYn: apiBrdInfo.btbdrpUseYn,
                    btbdcmUseYn: apiBrdInfo.btbdcmUseYn,
                    btbdrpBtbdcmUseYn: apiBrdInfo.btbdrpBtbdcmUseYn,
                    ppupSettPsblYn: apiBrdInfo.ppupSettPsblYn,
                    atcmUseYn: apiBrdInfo.atcmUseYn,
                    atcmUpldLmtNo: apiBrdInfo.atcmUpldLmtNo,
                    atcmCapcLmtYn: apiBrdInfo.atcmCapcLmtYn,
                    atcmLmtCapc: apiBrdInfo.atcmLmtCapc,
                    secrtBtbdmsUseYn: apiBrdInfo.secrtBtbdmsUseYn,
                    selcCntUseYn: apiBrdInfo.selcCntUseYn,
                    btbdmsSelcExuseYn: apiBrdInfo.btbdmsSelcExuseYn,
                    btbdrpSelcExuseYn: apiBrdInfo.btbdrpSelcExuseYn,
                    btbdrpSttsUseYn: apiBrdInfo.btbdrpSttsUseYn,
                    relaBltbrdUseYn: apiBrdInfo.relaBltbrdUseYn,
                    btbdmsTpCdValList: apiBrdInfo.bltbrdTpCdList,
                    reLaBltbrdList: apiBrdInfo.reLaBltbrdList,
                    chgYn: apiBrdInfo.chgYn,
                });

                form.btbdms.setValue("bltbrdUuid", data.bltbrdInfo.content.bltbrdUuid);

                if (apiBrdInfo.btbdrpSttsUseYn === "Y") {
                    // If it is a bulletin board that uses the progress of the answer when writing a post, the default value of the progress of the answer is applied ('U: Unchecked')
                    // 게시글 작성 시, 답변 진행상태를 사용하는 게시판 이라면, 답변 진행상태 기본값 적용('U : 미확인')
                    form.btbdms.setValue("btbdrpSttsCd", "U");
                }

                if (!comnUtils.isEmpty(data.bltbrdInfo.content.bltbrdTpCdList)) {
                    data.bltbrdInfo.content.bltbrdTpCdList.map((obj: any, index: any) => {
                        const isCode = obj.btbdmsTpCdValList[0]?.usrDefnVldVal1?.includes("COMI");
                        form.btbdms.setSchema(`btbdmsTpCd-${obj.btbdmsTpCd}-0`, {
                            label:
                                labelConversionMap.find((item) => item.comnCd === obj.usrDefnVldVal1)?.label ||
                                obj.btbdmsTpCdNm,
                            type: "select",
                            required: true,
                            ...(!isCode && {
                                options: obj.btbdmsTpCdValList.map((innerObj: any) => ({
                                    label: innerObj.cdVldValNm,
                                    value: innerObj.cdVldVal,
                                })),
                            }),
                            onChange: handler.viewSubCategory.bind(null, obj),
                            ...(obj.btbdmsTpCdValList[0]?.usrDefnVldVal1 === "COMI_CSTM_ORGZ_M" && {
                                area: "orgz",
                                type: "code",
                                label: "L_CSTM_SCTN",
                            }),
                            ...(obj.btbdmsTpCdValList[0]?.usrDefnVldVal1 === "COMI_USR_M" && {
                                area: "cstmOfcrCd",
                                type: "code",
                                label: "L_CHPN",
                            }),
                        });
                        obj.btbdmsTpCdValList.map((secondObj: any, index: any) => {
                            if (secondObj.subCategoryInfo) {
                                form.btbdms.setSchema(
                                    `btbdmsTpCd-${obj.btbdmsTpCd}-${secondObj.subCategoryInfo.uprCdVldVal}`,
                                    {
                                        label:
                                            labelConversionMap.find(
                                                (item) => item.comnCd === secondObj.subCategoryInfo?.comnCd,
                                            )?.label || secondObj.subCategoryInfo.cdVldValNm,
                                        type: "select",
                                        options: secondObj.subCategoryInfo.btbdmsTpCdValList.map(
                                            (thirdInnerObj: any) => ({
                                                label: thirdInnerObj.cdVldValNm,
                                                value: thirdInnerObj.cdVldVal,
                                            }),
                                        ),
                                    },
                                );
                            }
                        });
                    });
                }
                if (apiBrdInfo.atcmUpldLmtNo === 1) {
                    form.btbdms.setSchema("fileGrpUuid", { multiple: false });
                }
                if (apiBrdInfo.ppupSettPsblYn === "Y" && bltbrdUuid === "1860dd0c-b283-7cde-e063-020011ac3197") {
                    form.btbdms.setSchema("ppupYn", { label: "L_PUBL_FILE_YN" });
                }
                form.btbdms.setEditable(true);
            },
        }),

        // Save Bulletin board Management Information !== 게시글 등록 ==!
        registBtbdmsInfo: useFetch({
            api: (obj, btbdmsTpCdValList) =>
                APIS.registBtbdmsInfo({
                    ...obj,
                    btbdmsTpCdValList: btbdmsTpCdValList,
                }),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.00003", // Processed successfully. !== 성공적으로 처리 되었습니다. ==!
                    onCancel: () => {
                        navigate(`${URLS.ptli1018001q}?menuId=${menuId}&bltbrdUuid=${bltbrdUuid}`);
                    },
                });
            },
            onError: () => {},
            showToast: true,
        }),
    };

    const handler = {
        onListBtnClick: () => navigate(`${URLS.ptli1018001q}?menuId=${menuId}&bltbrdUuid=${bltbrdUuid}`),

        ppupYnChange: () => {
            const ppupYn = form.btbdms.getValue("ppupYn");
            if (comnUtils.isEmpty(ppupYn)) {
                setPpupYn(false);
            }
            if (ppupYn === "Y") {
                setPpupYn(true);
            } else {
                setPpupYn(false);
            }
            if (bltbrdUuid === "1860dd0c-b283-7cde-e063-020011ac3197") {
                if (ppupYn === "Y") {
                    form.btbdms.setSchema("fileGrpUuid", { isPublic: true });
                    setPpupYn(false);
                } else {
                    form.btbdms.setSchema("fileGrpUuid", { isPublic: false });
                    setPpupYn(false);
                }
            }
        },

        onSubmitBtnClick: form.btbdms.handleSubmit(
            () => {
                if (!handler.validChk()) return;
                // Before transferring, processing bulletin board type code value data !== 전송 전, 게시판유형코드값 data 형태 가공 ==!
                let obj = form.btbdms.getValues();
                let btbdmsTpCdValList = Object.keys(obj)
                    .filter((key: any) => key.startsWith("btbdmsTpCd"))
                    .map((key: any) => {
                        let btbdmsTpCd = key.split("-")[1];
                        let uprCdVldVal = key.split("-")[2];
                        if (uprCdVldVal !== "0") {
                            const category = subCategory.filter(
                                (category: any) => category.uprCdVldVal === uprCdVldVal,
                            );
                            if (category.length === 0) {
                                return;
                            }
                        }

                        return {
                            bltbrdUuid: bltbrdInfo?.bltbrdUuid,
                            btbdmsTpCd: btbdmsTpCd,
                            uprCdVldVal: uprCdVldVal,
                            btbdmsTpCdVal: obj[key],
                        };
                    });

                if (typeof obj.fileGrpUuid === "object") {
                    obj.fileSaveDto = obj.fileGrpUuid;
                    obj.fileGrpUuid = null;
                }
                btbdmsTpCdValList = btbdmsTpCdValList.filter((item) => item !== undefined);
                modal.openModal({
                    content: "msg.com.00047", // Confirm save? !== 저장하시겠습니까? ==!
                    onConfirm: () => fetch.registBtbdmsInfo.fetch(obj, btbdmsTpCdValList),
                });
            },
            (err) => {
                form.btbdms.setFocus(err[0]);
                toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid !== 데이터가 유효하지 않습니다. ==!
            },
        ),

        validChk: () => {
            const ppupYn = form.btbdms.getValue("ppupYn");
            if (ppupYn === "Y" && bltbrdUuid !== "1860dd0c-b283-7cde-e063-020011ac3197") {
                const ppupStrtDtm = form.btbdms.getValue("ppupStrtDtm");
                const ppupEndDtm = form.btbdms.getValue("ppupEndDtm");
                if (comnUtils.isEmpty(ppupStrtDtm)) {
                    form.btbdms.setError("ppupStrtDtm", {
                        message: "msg.com.00005", // Mandatory fields !== 필수 입력 필드 ==!
                    });
                    return false;
                } else if (comnUtils.isEmpty(ppupEndDtm)) {
                    form.btbdms.setError("ppupEndDtm", {
                        message: "msg.com.00005", // Mandatory fields !== 필수 입력 필드 ==!
                    });
                    return false;
                } else if (ppupEndDtm < ppupStrtDtm) {
                    form.btbdms.setError("ppupStrtDtm", {
                        message: "msg.cgm.00034", // Start date cannot be later than end date. !== 시작일자는 종료일자보다 이후일 수 없습니다. ==!
                    });
                    return false;
                } else {
                    form.btbdms.clearErrors("ppupStrtDtm");
                    form.btbdms.clearErrors("ppupEndDtm");
                    return true;
                }
            } else {
                return true;
            }
        },

        fileOnChange: (data: any) => {
            // Check attachment capacity limitation !== 첨부파일 용량 제한 여부 확인 ==!
            if (bltbrdInfo?.atcmCapcLmtYn === "Y") {
            }
            if (bltbrdInfo?.atcmUpldLmtNo !== undefined) {
                if (parseInt(bltbrdInfo?.atcmUpldLmtNo.toString()) < data.fileSaveReqDtoList.length) {
                    return false;
                }
            }
        },

        viewSubCategory: (data: any, value: string) => {
            const subCategoryData = data.btbdmsTpCdValList.find((obj: any) => obj.cdVldVal === value);
            if (subCategoryData?.subCategoryInfo) {
                const comnCd = subCategoryData.comnCd;
                console.log(comnCd);
                let newSubCategory = [...subCategory];
                let index = newSubCategory.findIndex((item) => item.comnCd === comnCd);
                if (index > -1) {
                    newSubCategory[index] = { comnCd: comnCd, uprCdVldVal: value };
                } else {
                    newSubCategory.push({ comnCd: comnCd, uprCdVldVal: value });
                }
                setSubCategory(newSubCategory);
            }
        },
    };

    useEffect(() => {
        // Check bulletin board information !== 게시판 정보 조회==!
        fetch.getBltbrdInfo.fetch();
    }, []);

    useEffect(() => {
        fetch.getBltbrdInfo.fetch();
    }, [theme]);

    return (
        <Page
            title={
                bltbrdInfo &&
                (lang === "ko"
                    ? bltbrdInfo.bltbrdKoNm
                    : lang === "en"
                      ? bltbrdInfo.bltbrdEngNm
                      : lang === "tz"
                        ? bltbrdInfo.bltbrdTzNm
                        : "")
            }
        >
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.btbdms.schema.btbdmsTtleNm} controlSize={10} />
                        </Group.Row>

                        {bltbrdInfo &&
                            bltbrdInfo.btbdmsTpCdValList &&
                            bltbrdInfo.btbdmsTpCdValList.map((obj: any, index: number) => {
                                return (
                                    <Group.Row key={index}>
                                        <Group.Control {...form.btbdms.schema[`btbdmsTpCd-${obj.btbdmsTpCd}-0`]} />
                                        {obj.usrDefnVldVal1 &&
                                            subCategory
                                                .filter((category: any) => category.comnCd === obj.usrDefnVldVal1)
                                                .map((category: any) => (
                                                    <Group.Control
                                                        key={category.subComnCd}
                                                        {...form.btbdms.schema[
                                                            `btbdmsTpCd-${obj.btbdmsTpCd}-${category.uprCdVldVal}`
                                                        ]}
                                                    />
                                                ))}
                                    </Group.Row>
                                );
                            })}

                        <Group.Row>
                            <Group.Control {...form.btbdms.schema.btbdmsCn} controlSize={10} />
                        </Group.Row>
                        {bltbrdInfo && bltbrdInfo.ppupSettPsblYn == "Y" && (
                            <Group.Row>
                                <Group.Control
                                    {...form.btbdms.schema.ppupYn}
                                    onChange={() => {
                                        handler.ppupYnChange();
                                    }}
                                />
                                {ppupYn && (
                                    <>
                                        <Group.Label label={t("L_PPUP_DATE")} size={2} />
                                        <Group.Col>
                                            <Group.Control {...form.btbdms.schema.ppupStrtDtm} controlSize={4} />
                                            <Group.Col size={2}>~</Group.Col>
                                            <Group.Control {...form.btbdms.schema.ppupEndDtm} controlSize={4} />
                                        </Group.Col>
                                    </>
                                )}
                            </Group.Row>
                        )}
                        {bltbrdInfo && bltbrdInfo.secrtBtbdmsUseYn == "Y" && (
                            <Group.Row>
                                <Group.Control {...form.btbdms.schema.secrtBtbdmsYn} />
                            </Group.Row>
                        )}
                        {bltbrdInfo && bltbrdInfo.atcmUseYn == "Y" && (
                            <Group.Row>
                                <Group.Control {...form.btbdms.schema.fileGrpUuid} onChange={handler.fileOnChange} />
                            </Group.Row>
                        )}
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout direction="row">
                <Layout.Left>
                    <Layout.Button role={"list"} onClick={() => handler.onListBtnClick()} />
                </Layout.Left>
                <Layout.Right>
                    <Layout.Button role={"save"} onClick={() => handler.onSubmitBtnClick()} />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
